module.exports = __webpack_public_path__ + "fonts/juwel_bb503498c73bf6ea6f6aa2b40a7134b1.ttf";